import React, { useState } from "react";
import close from "../../../assets/images/close.svg";
import { Nav, Row, Tab } from "react-bootstrap";
import downarrow from "../../../assets/images/downarrow.svg";
import uparrow from "../../../assets/images/uparrow.svg";

const LOGIN_TYPES = ["UserName", "GitHub", "Google", "Invite", "SSO"];
const SORT_FIELDS = ["Date", "User Name", "Login Type", "IP Address", "Device"];

const LoginLogFilterPopup = ({
  sortStatePayload,
  setSortStatePayload,
  filters,
  setFilters,
  handleshowPopup,
}) => {
  const initJson = {
    Sort: {
      field: sortStatePayload?.field || null,
      direction: sortStatePayload?.direction || null,
    },
    Filter: {
      logintype: filters?.logintype || "",
    },
  };

  const [filterSort, setFilterSort] = useState(initJson);
  const [sortState, setSortState] = useState({
    field: sortStatePayload?.field || null,
    direction: sortStatePayload?.direction || null,
  });

  const handleReset = () => {
    setSortStatePayload({ field: null, direction: null });
    setSortState({ field: null, direction: null });
    setFilterSort({
      Sort: { field: null, direction: null },
      Filter: { logintype: "" },
    });
    setFilters({ logintype: "" });
  };

  const handleApply = (e) => {
    setSortStatePayload(sortState);
    setFilters(filterSort.Filter);
    handleshowPopup(e);
  };

  const handleLoginTypeClick = (type) => {
    const current = filterSort.Filter.logintype;
    const isSelected = current === type;
    setFilterSort({
      ...filterSort,
      Filter: {
        ...filterSort.Filter,
        logintype: isSelected ? "" : type,
      },
    });
  };

  const handleSortClick = (field, direction) => {
    if (sortState.field === field && sortState.direction === direction) {
      setSortState({ field: null, direction: null });
    } else {
      setSortState({ field, direction });
    }
  };

  return (
    <Tab.Container
      id="loginlog-tabs-example"
      defaultActiveKey="first"
      className="underlined-tabing"
    >
      <div className="schedular-popup sort-and-filter-popup">
        <div className="popup-title d-block p-0">
          <Nav variant="pills" className="flex">
            <Nav.Item>
              <Nav.Link eventKey="first">Filter</Nav.Link>
            </Nav.Item>
            <Nav.Item className="position-relative">
              <Nav.Link eventKey="second">Sort</Nav.Link>
              <img
                src={close}
                alt="close"
                id="sort-filter"
                className="cursor-pointer"
                onClick={(e) => handleshowPopup(e)}
              />
            </Nav.Item>
          </Nav>
        </div>
        <div className="popup-body">
          <Tab.Content>
            <Tab.Pane eventKey="first">
              <div className="logfilterpopup">
                <Row>
                  <div className="single-filter">
                    <div className="d-flex align-items-center justify-content-between common-tab-titles">
                      <h5>Login Type</h5>
                    </div>
                    <div className="all-grey-blue-badges">
                      {LOGIN_TYPES.map((type) => (
                        <span
                          key={type}
                          className={
                            filterSort?.Filter?.logintype === type
                              ? "grey-badge active"
                              : "grey-badge"
                          }
                          onClick={() => handleLoginTypeClick(type)}
                        >
                          {type}
                        </span>
                      ))}
                    </div>
                  </div>
                </Row>
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="second">
              <div className="logfilterpopup">
                <Row>
                  {SORT_FIELDS.map((field) => (
                    <div key={field} className="single-filter">
                      <div className="d-flex align-items-center justify-content-between common-tab-titles">
                        <h5>{field}</h5>
                        <div className="d-flex gap-2 all-grey-blue-badges">
                          <p
                            className={
                              sortState.field === field &&
                              sortState.direction === "ASC"
                                ? "grey-badge filter-up-down-icon active"
                                : "grey-badge filter-up-down-icon"
                            }
                            onClick={() => handleSortClick(field, "ASC")}
                          >
                            <img src={uparrow} alt="uparrow" />
                          </p>
                          <p
                            className={
                              sortState.field === field &&
                              sortState.direction === "DESC"
                                ? "grey-badge filter-up-down-icon active"
                                : "grey-badge filter-up-down-icon"
                            }
                            onClick={() => handleSortClick(field, "DESC")}
                          >
                            <img src={downarrow} alt="downarrow" />
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </Row>
              </div>
            </Tab.Pane>
          </Tab.Content>
        </div>
        <div className="popup-footer">
          <button className="grey-btn" onClick={handleReset}>
            Reset
          </button>
          <button className="blue-btn" onClick={handleApply}>
            Apply
          </button>
        </div>
      </div>
    </Tab.Container>
  );
};

export default LoginLogFilterPopup;
